import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ROLE, STATUSCODESTRING, constantStrings } from '@shared/helpers/constants';
import { HILCaseDetails, IMGCenterDetails } from '@shared/models/user.model';
import { AuthService } from '@shared/services/auth.service';
import { CasedashboardService } from '../casedashboard.service';
import { DialogData } from '../interface/casehistory.interface';

@Component({
  selector: 'app-casedialog',
  templateUrl: './casedialog.component.html',
  styleUrls: ['./casedialog.component.scss']
})
export class CasedialogComponent implements OnInit {
  loggedInUser: string | undefined;
  isManagerFlag: boolean = false;
  isReviewerFlag: boolean = false;
  displaySpinner: boolean;
  showCaseFlag: boolean = false;
  showImgCenterFlag: boolean = false;
  errorInCaseDialogDetails: any;
  errorInCaseDetails: any;
  hilCaseDetails: HILCaseDetails;
  imgCenterDetails: IMGCenterDetails;
  userInfo: any;
  statusRejected = STATUSCODESTRING.statusRejected;
  statusApproved = STATUSCODESTRING.statusApproved;
  statusError=STATUSCODESTRING.statusError;
  notApplicable =  constantStrings.NOT_APPLICABLE;
  constructor(
    public dialogRef: MatDialogRef<CasedialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private casedashboardService: CasedashboardService,
    private authService: AuthService
  ) { }
  onCancel(): void {
    this.dialogRef.close();
  }
  /**
   * The ngOnInit function initializes variables and calls functions to retrieve case and facility
   * details based on the user's role.
   */
  ngOnInit(): void {
    const idToken = this.authService.getCognitoAccessTokenFromStorage();
    const decodedValue = this.authService.decode(idToken);
    this.loggedInUser = decodedValue ? decodedValue['cognito:groups'][0] : '';
    if (this.loggedInUser == ROLE.SNN_HIL_MANAGER) {
      this.isManagerFlag = true
    } else if (this.loggedInUser == ROLE.SNN_HIL_REVIEWER) {
      this.isReviewerFlag = true
    }
    this.hilCaseDetails = {
      createdDateTime: null,
      applicationName: '',
      anatomy: null,
      imagingType: '',
      claimantFirstName: '',
      claimantLastName: '',
      errorNotes: '',
      updatedDateTime: null,
      caseType: ''
    }
    this.imgCenterDetails = {
      facilityName: '',
      address: '',
      city: '',
      state: '',
      facilityContactLead: '',
      facilityEmail: '',
      facilityPhone: null,
      zipCode: ''
    }
    let caseId = this.data.id;
    this.getCasedetails(caseId);
    let facilityIds = [+this.data.faciltyId];
    if (this.isManagerFlag) {
      this.getFacility(facilityIds);
    }
  }
  /**
   * This function retrieves case details from a service and displays them, while handling errors.
   * @param param - The parameter "param" is being passed to the "getCasedetails" function. It is not
   * clear what data type "param" is, as it is not specified in the code snippet. It could be a string,
   * number, object, or any other data type depending on the implementation of the
   */
  public getCasedetails(param): any {
    this.displaySpinner = true;
    this.casedashboardService.getCasedetails(param).subscribe({
      next: Response => {
        let result = Response;
        this.displaySpinner = false;
        this.hilCaseDetails = result;
        this.showCaseFlag = true;
      },
      error: error => {
        this.errorInCaseDetails = error;
        this.displaySpinner = false;
      }
    })
  }
  /**
   * This function retrieves facility details from an API and displays them in the UI.
   * @param facilityId - The ID of the facility for which details are being requested.
   */
  public getFacility(facilityId): any {
    this.casedashboardService.getFacilitydetails(facilityId).subscribe({
      next: Response => {
        this.imgCenterDetails = Response[0];
        if (Response.length > 0)
          this.showImgCenterFlag = true;
      },
      error: error => {
        this.errorInCaseDialogDetails = error;
        this.displaySpinner = false;
      }
    })
  }
}
